var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('p',[_c('span',{staticClass:"btn btn-clear",on:{"click":function($event){_vm.$store.commit('search/SET_BACKBTN_RESULTS', true),_vm.$router.back()}}},[_vm._v("Back")])])])}
var staticRenderFns = []

export { render, staticRenderFns }